import { ImageSourceHelper } from '@sortlist-frontend/media';
import { useWindowMessage, WindowMessageParams } from '@sortlist-frontend/utils';
import { useState } from 'react';

import { WorkNode } from '_features/AgencyProfile/components/PortfolioPanel/types';
import { Agency, WorkIncludedAttributes } from '_types/public-api';

import { WorkDetailModal } from './WorkDetailModal';

type Action = 'open-work-dialog' | 'close-work-dialog';
type Data = { workSlug: string; agencyId: string; currentIndex: number };

export const useWorkMessage = (params?: WindowMessageParams<Action, Data>) => useWindowMessage<Action, Data>(params);

type Props = {
  works?: WorkIncludedAttributes[];
  agencies?: Agency[];
};
const missingAgencyLogo = ImageSourceHelper.fromPath('/_img/default/default-image-square.svg');

export const WorkDetailModalEmbed = (props: Props) => {
  const [open, setOpen] = useState(false);
  const [selectedWork, setSelectedWork] = useState<WorkIncludedAttributes | null>(null);
  const [selectedAgency, setSelectedAgency] = useState<Agency | null>(null);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const { works, agencies } = props;

  const workSlugs = works?.map((work) => work.attributes.slug);

  const { sendMessageToParent } = useWorkMessage({
    onReceiveMessage: (action, data) => {
      if (action === 'open-work-dialog') {
        setSelectedAgency(agencies?.find((agency) => agency.id === data?.agencyId) ?? null);
        setSelectedWork(works?.find((work) => work.attributes.slug === data?.workSlug) ?? null);
        setCurrentIndex(data?.currentIndex ?? 0);
        setOpen(true);
      }
      if (action === 'close-work-dialog') {
        setSelectedAgency(null);
        setSelectedWork(null);
        setCurrentIndex(-1);
        setOpen(false);
      }
    },
    sendToIframeId: 'directory-actions',
  });

  const transformedWorksForModal = works?.map((work) => {
    return {
      slug: work.attributes.slug,
      name: work.attributes.name,
      description: work.attributes.description,
      illustrationUrls:
        work.attributes.illustration_url != null ? [work.attributes.illustration_url] : [missingAgencyLogo],
      company: {
        sector: '',
      },
    };
  });

  return open && selectedAgency != null && selectedWork != null ? (
    <WorkDetailModal
      onClose={() => {
        sendMessageToParent('close-work-dialog');
        setOpen(false);
      }}
      workSlug={selectedWork.attributes.slug}
      workSlugs={workSlugs}
      works={transformedWorksForModal as unknown as WorkNode[]}
      longtailsPage={true} // @TODO -> this should be removed/refactored
      index={currentIndex}
      open
    />
  ) : null;
};
